// extracted by mini-css-extract-plugin
module.exports = {"gridPhoto":"PlanningAhead_gridPhoto__l_F7r","gridPhotoLink":"PlanningAhead_gridPhotoLink__ynUEs"};